<template>
  <div>
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center titulo-sagres font-weight-bold">
          Meus recibos de protocolos
        </h6>
      </template>
      <b-card-text>
        <b-table :busy="isBusy" :fields="fields" hover no-border-collapse :items="items" sort-by="DtProtocolo"
          :sort-desc="true" striped small show-empty stacked="md">
          <template #empty>
            <span>Não foram encontrados recibos.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados recibos.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="actions-icons">
              <btn-download :fazerDownload="baixarRecibo" :parametros="row.item" />
            </div>
          </template>
        </b-table>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import protocoloService from "@/services/processos-eletronicos/protocoloService";
import reportService from "@/services/reportService";
import BtnDownload from "@/components/shared/btn-download.vue";
import { tableFieldsMeusRecibos } from '@/types/processo-eletronico/table-fields-meus-recibos'
import { UtilsTS } from '@/utilsts';

export default {
  name: "MeusRecibos",
  mixins: [UtilsTS],
  components: {
    BtnDownload
  },
  data() {
    return {
      isBusy: false,
      fields: [...tableFieldsMeusRecibos],
      items: [],
      mostrarModalDesativarAviso: false,
    };
  },
  methods: {
    async getMeusRecibos() {
      try {
        this.isBusy = true;
        const response = await protocoloService.listarRecibosDoUsuario();
        //console.log(response.data);
        if (response && response.status == 200) {
          this.items = response.data.map(mr => {
            return {
              ...mr,
              DtProtocolo: this.formatData(mr.DtProtocolo)
            }
          });
        } else {
          this.$toast.error("Erro ao obter os recibos de protocolos.");
        }
      } catch (err) {
        console.error("Erro ao obter os recibos de protocolo: ", err);
        this.$toast.error(err.message);
      } finally {
        this.isBusy = false;
      }
    },
    async baixarRecibo(recibo) {
      const response = await reportService.getReciboProtocolo(recibo.Id)
      if (response && response.status == 200) {
        this.download(`recibo-${recibo.NrProtocolo ?? 'protocolo'}.pdf`, response.data);
      } else {
        if (response && response.status === 404)
          this.$toast.error("Erro ao obter o recibo do protocolo");
        else if (response.data.msg) this.$toast.error(response.data.msg);
        else this.$toast.error("Erro ao obter o recibo do protocolo");
      }
    },
  },
  async mounted() {
    await this.getMeusRecibos();
  },
};
</script>

<style>
</style>